import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import {computed, ref} from 'vue';
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import AbstractOperatorApplicationDesktopPlatform
    from "~/operatorApplication/ts/platform/AbstractOperatorApplicationDesktopPlatform";
import {OPERATOR_APPLICATION_BRANDS} from "~/operatorApplication/ts/data/OperatorApplicationBrands";
import {LatestOperatorApplicationVersion} from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {__} from "~/ts/library/Translate";



const __default__ = {
    name: "OperatorApplicationUpdate"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let currentVersion = ref<string>();
let brandId = ref<string>();
let checkingForUpdate = ref(false);
let latestVersion = ref<LatestOperatorApplicationVersion>();

let platform = computed(() => {
    let platform = OperatorApplicationPlatformFactory;
    if (platform instanceof AbstractOperatorApplicationDesktopPlatform) {
        return platform;
    }
    throw new Error("Не десктопная платформа");
});

(async function () {
    brandId.value = await platform.value.getBrandId();
    currentVersion.value = await updater.value.getCurrentApplicationVersion();
    checkForUpdates();
})()

let brand = computed(() => {
    return OPERATOR_APPLICATION_BRANDS[brandId.value];
});

let appDescr = computed(() => {
    return brand.value.descr;
});

let updater = computed(() => {
    return platform.value.updater;
});


async function checkForUpdates() {
    checkingForUpdate.value = true;
    latestVersion.value = null;
    let checkForUpdatesResult = await updater.value.checkForUpdates();
    if (checkForUpdatesResult && checkForUpdatesResult.version !== currentVersion.value) {
        latestVersion.value = checkForUpdatesResult;
    }
    checkingForUpdate.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(brand) && _unref(currentVersion))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Текущая версия %s", _unref(appDescr))) + ": " + _toDisplayString(_unref(currentVersion)), 1),
        _createElementVNode("div", null, [
          (_unref(checkingForUpdate))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(MyLoader),
                _createTextVNode(" " + _toDisplayString(_unref(__)("Поиск обновлений")) + "... ", 1)
              ], 64))
            : (_unref(latestVersion))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", null, _toDisplayString(_unref(__)("Доступна новая версия %s", _unref(latestVersion).version)) + ". ", 1),
                  _createElementVNode("p", null, [
                    (_unref(updater).isReadyToUpdate)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(updater).make()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(__)("Перезапустить приложение")), 1)
                          ]),
                          _: 1
                        }))
                      : (_unref(updater).isUpdatedDownloading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(MyLoader),
                            _createTextVNode(" " + _toDisplayString(_unref(__)("Подождите, идет загрузка")) + "... ", 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            type: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(updater).fetchUpdate(_unref(latestVersion))))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(__)("Скачать обновление ")), 1)
                            ]),
                            _: 1
                          }))
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_unref(__)("Вы используете последнюю версию %s", _unref(appDescr))) + ". ", 1),
                  _createVNode(_component_el_button, {
                    link: "",
                    onClick: checkForUpdates
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(__)("Проверить обновления")), 1)
                    ]),
                    _: 1
                  })
                ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})